import { CREATE_INTERNAL_PRICE_QUOTE } from './reservationsPermissions';

export const REPORTS_MODULE = 'REPORTS_MODULE';

// export const VIEW_REPORTS = CREATE_INTERNAL_PRICE_QUOTE;
// export const DOWNLOAD_REPORTS = CREATE_INTERNAL_PRICE_QUOTE;
export const VIEW_REPORTS = 'VIEW_REPORTS';
export const DOWNLOAD_REPORTS = VIEW_REPORTS;
